import _ from 'lodash'

/**  封禁用户设备 编辑回显数据格式化 */
export const formatEditData = (row) => {
  const data = _.cloneDeep(row);
  /** 本地音频封禁 */
  data.localAudioFlag = row.lanAudioFlag
  /** 本地图片封禁 */
  data.localPicFlag = row.lanPicFlag
  /** 本地视频封禁 */
  data.localVideoFlag = row.lanVideoFlag
  /** 在线音频封禁 */
  data.onlineAudioFlag = row.lanAudioFlag
  /** 在线图片封禁  */
  data.onlinePicFlag = row.lanPicFlag
  /** 在线视频封禁 */
  data.onlineVideoFlag = row.lanVideoFlag

  return data
}